import React, { useRef } from 'react'
import logo from '../ui/logo.svg'
import { NavLink } from 'react-router-dom'


import './header.css'

import MainMenu from './MainMenu';




const Header = () => {


    const logoRef = useRef();

    const handleOnclickMenue = () => {

        if (window.innerWidth <= 768) {
            logoRef.current.style.display =
                logoRef.current.style.display === 'none' ? 'block' : 'none';
        }
    }



    return (
        <>






            <div >



                <div id='header'>
                    <div ref={logoRef}>
                        <NavLink to="">
                            <img src={logo} alt="Logo" id='logo' />

                        </NavLink>

                    </div>

                    <div onClick={handleOnclickMenue}>
                        <MainMenu />
                    </div>


                </div>












            </div>


            {/* <MainMenu /> */}




        </>
    )
}

export default Header


